// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 129,
  argument: "A prayer of a sinner trusting in the mercies of God. The 6th penitential psalm.",
  verses: [
    { n: 1, text: "A gradual canticle. Out of the depths I have cried to thee, O Lord:" },
    { n: 2, text: "Lord, hear my voice. Let thy ears be attentive to the voice of my supplication." },
    { n: 3, text: "If thou, O Lord, wilt mark iniquities; Lord, who shall stand?" },
    { n: 4, text: "For with thee there is merciful forgiveness: and by reason of thy law, I have waited for thee, O Lord. My soul hath relied on his word: 5 my soul hath hoped in the Lord." },
    { n: 6, text: "From the morning watch even until night, let Israel hope in the Lord." },
    { n: 7, text: "Because with the Lord there is mercy; and with him plentiful redemption." },
    { n: 8, text: "And he shall redeem Israel from all his iniquities." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Canticle. David might compose it after his sin, though it might suit the captives, and all sinners, as well as the souls in purgatory. (Berthier) — It has long been recited in their behalf. (Worthington) — Depths of the prison of expiation, or from this vale of misery, (Berthier) captivity, (Calmet) and from the bottom of my heart.", attribution: "St. Chrysostom" }
    ] },
    { verse: 3, notes: [
      { text: "Mark. Hebrew, \"observe or keep.\" — It. Hebrew, \"who shall stand upright, (Calmet) or make opposition.\" (Haydock) — We all stand in need of mercy, as none can stand before the rigours of divine justice. (Worthington) Si quoties homines peccant, sua fulmina mittat Jupiter, exiguo tempore inermis erit. (Trist. ii. )", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "Law. That promises of pardon contained therein. (Worthington) — Hebrew is now different from what the ancient interpreters read. (Calmet) — \"Therefore shalt thou be feared.\" (Montanus) (Haydock) — Symmachus and Theodotion agree with us.", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "Word. And promises that the captivity should end, (Calmet) and sin be remitted.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "From. Or Hebrew, \"more than the morning watch; yea, more than the morning watch.\" I expect my deliverance with greater eagerness than sentinels do the return of morning. All the day and night long I am filled with these sentiments. (Calmet) — The hope of penitents resembles the watches of the day, which are more comfortable than those of the night.", attribution: "Worthington" }
    ] },
    { verse: 7, notes: [
      { text: "Redemption. Our Saviour affords the greatest consolation. (Worthington) — He will save the people, Matthew i. 21., and 1 John ii. 2.", attribution: "Berthier" }
    ] },
  ],
};

export default chapter;
